/**
 * @desc 财务收支应用表列表(敏感信息不返回)
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  Array<defs.basics.FinanceAccountDesensitizationResponseDto>
>;
export function request(
  body: defs.basics.FinanceAccountRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/financeAccount/listDesensitization`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
